import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

export default function UncoveredAthletesAlert({ days = 30, groupId = "", compact = false }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/lessons-archive/uncovered", { params: { days, ...(groupId ? { group_id: groupId } : {}) } }).then((r) => setD(r.data)).catch(() => setD(null));
  }, [days, groupId]);
  if (!d) return null;
  return (
    <div className={`rounded-md border ${d.uncovered ? "border-amber-300 bg-amber-50" : "border-emerald-200 bg-emerald-50"} p-4`} data-testid="uncovered-alert">
      <div className="flex items-center gap-2 flex-wrap">
        <AlertTriangle className={`w-4 h-4 ${d.uncovered ? "text-amber-600" : "text-emerald-600"}`} />
        <span className="font-semibold text-sm" data-testid="uncovered-count">
          {d.uncovered === 0 ? `Tutti i ${d.agonisti_total} agonisti hanno una lezione individuale negli ultimi ${days} giorni` : `${d.uncovered} agonisti su ${d.agonisti_total} senza lezione individuale da più di ${days} giorni`}
        </span>
        {d.never > 0 && <span className="text-xs text-amber-800 font-mono">· {d.never} mai registrata</span>}
        {d.unclassified > 0 && <span className="text-[10px] text-zinc-500">· {d.unclassified} atleti non classificati agonista/non agonista (usato livello monitoraggio)</span>}
      </div>
      {d.uncovered > 0 && (
        <div className={`mt-2 flex flex-wrap gap-1.5 ${compact ? "max-h-24 overflow-y-auto" : ""}`}>
          {d.items.map((a) => (
            <Link key={a.id} to={`/atleti/${a.id}`} data-testid={`uncovered-${a.id}`} className="text-[11px] px-2 py-1 rounded-full bg-white border border-amber-200 hover:border-black" title={a.group_name || ""}>
              {a.name} <span className="font-mono text-amber-800">{a.days_since_last == null ? "mai" : `${a.days_since_last}gg`}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
